var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.close,
          expression: "close",
        },
      ],
      staticClass: "bg-picker",
      class: { "is-dragging-over": _vm.isDraggingOver },
      on: {
        dragenter: function ($event) {
          $event.preventDefault()
          return _vm.onDragEnter.apply(null, arguments)
        },
        dragover: function ($event) {
          $event.preventDefault()
          return _vm.onDragOver.apply(null, arguments)
        },
        dragleave: function ($event) {
          $event.preventDefault()
          return _vm.onDragLeave.apply(null, arguments)
        },
        drop: function ($event) {
          $event.preventDefault()
          return _vm.onDrop.apply(null, arguments)
        },
      },
    },
    [
      _c(
        "button",
        {
          staticClass: "dbh-btn--outline dbh-btn text-sm",
          class: { "is-open": _vm.isOpen },
          attrs: {
            title: _vm.triggerTitle,
            "aria-expanded": _vm.isOpen.toString(),
            "aria-haspopup": "true",
          },
          on: { click: _vm.toggle },
        },
        [
          _c(
            "svg",
            {
              attrs: {
                width: "16",
                height: "16",
                viewBox: "0 0 16 16",
                fill: "none",
                "aria-hidden": "true",
              },
            },
            [
              _c("rect", {
                attrs: {
                  x: "1",
                  y: "1",
                  width: "14",
                  height: "14",
                  rx: "2",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  fill: "none",
                },
              }),
              _vm._v(" "),
              _c("path", {
                attrs: {
                  d: "M1 10l4-4 3.5 3.5L12 5l3 5",
                  stroke: "currentColor",
                  "stroke-width": "1.4",
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  fill: "none",
                },
              }),
              _vm._v(" "),
              _c("circle", {
                attrs: { cx: "5.5", cy: "6", r: "1.2", fill: "currentColor" },
              }),
            ]
          ),
          _vm._v(" "),
          _c("span", { staticClass: "ml-1" }, [_vm._v("Background")]),
        ]
      ),
      _vm._v(" "),
      _c("transition", { attrs: { name: "bg-picker__panel" } }, [
        _vm.isOpen
          ? _c(
              "div",
              {
                staticClass: "bg-picker__panel",
                style: _vm.panelPositionStyle,
                attrs: { role: "menu" },
              },
              [
                _c("p", { staticClass: "bg-picker__panel-title" }, [
                  _vm._v("\n        Background\n      "),
                ]),
                _vm._v(" "),
                _vm._l(_vm.displayLayers, function (layer) {
                  return _c(
                    "div",
                    { key: layer.role, staticClass: "bg-picker__layer py-2" },
                    [
                      _c("div", { staticClass: "bg-picker__layer-head" }, [
                        _c("div", [
                          _c("small", [_vm._v(_vm._s(layer.description))]),
                        ]),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "d-flex align-items-center gap-1" },
                          [
                            _vm.hasDownloadableLayer(layer.role)
                              ? _c(
                                  "button",
                                  {
                                    staticClass:
                                      "download-btn d-flex align-items-center gap-1",
                                    attrs: {
                                      type: "button",
                                      disabled:
                                        _vm.downloadingRole === layer.role,
                                      "aria-label": `Download ${layer.label}`,
                                    },
                                    on: {
                                      click: function ($event) {
                                        $event.stopPropagation()
                                        return _vm.downloadLayer(layer)
                                      },
                                    },
                                  },
                                  [
                                    _c(
                                      "svg",
                                      {
                                        staticClass:
                                          "lucide lucide-download-icon lucide-download",
                                        attrs: {
                                          xmlns: "http://www.w3.org/2000/svg",
                                          width: "24",
                                          height: "24",
                                          viewBox: "0 0 24 24",
                                          fill: "none",
                                          stroke: "currentColor",
                                          "stroke-width": "2",
                                          "stroke-linecap": "round",
                                          "stroke-linejoin": "round",
                                        },
                                      },
                                      [
                                        _c("path", {
                                          attrs: { d: "M12 15V3" },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: {
                                            d: "M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4",
                                          },
                                        }),
                                        _vm._v(" "),
                                        _c("path", {
                                          attrs: { d: "m7 10 5 5 5-5" },
                                        }),
                                      ]
                                    ),
                                    _vm._v(
                                      "\n              Download\n            "
                                    ),
                                  ]
                                )
                              : _vm._e(),
                            _vm._v(" "),
                            !layer.optional
                              ? _c(
                                  "span",
                                  {
                                    staticClass:
                                      "bg-picker__status bg-picker__status--set",
                                  },
                                  [_vm._v("\n              Set\n            ")]
                                )
                              : _c(
                                  "span",
                                  {
                                    staticClass: "bg-picker__status",
                                    class: {
                                      "bg-picker__status--set": _vm.hasLayer(
                                        layer.role
                                      ),
                                    },
                                  },
                                  [
                                    _vm._v(
                                      "\n              " +
                                        _vm._s(
                                          _vm.hasLayer(layer.role)
                                            ? "Set"
                                            : "(optional)"
                                        ) +
                                        "\n            "
                                    ),
                                  ]
                                ),
                          ]
                        ),
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "bg-picker__layer-actions" }, [
                        _c(
                          "button",
                          {
                            staticClass: "bg-picker__option",
                            attrs: {
                              role: "menuitem",
                              disabled: _vm.layerBusy,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.triggerUpload(layer.role)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-upload" }),
                            _vm._v("\n            Upload\n          "),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "button",
                          {
                            staticClass: "bg-picker__option",
                            attrs: {
                              role: "menuitem",
                              disabled: _vm.layerBusy,
                            },
                            on: {
                              click: function ($event) {
                                return _vm.pickFromFiles(layer.role)
                              },
                            },
                          },
                          [
                            _c("i", { staticClass: "bi bi-folder" }),
                            _vm._v("\n            Files\n          "),
                          ]
                        ),
                      ]),
                    ]
                  )
                }),
                _vm._v(" "),
                _c("input", {
                  ref: "fileInput",
                  staticClass: "bg-picker__file-input",
                  attrs: { type: "file", accept: "image/*" },
                  on: { change: _vm.onFileSelected },
                }),
              ],
              2
            )
          : _vm._e(),
      ]),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }